export const BASE_URL: string = import.meta.env.VITE_APP_BACKEND_DOMAIN_NAME

export const API_ROUTES = {
  BASE_URL,
  USER_LOGIN: `${BASE_URL}/user-login`,
  USER_REGISTER: `${BASE_URL}/user-register`,
  USER_JWT_REFRESH: `${BASE_URL}/user-jwt-refresh`,
  USER_LOGOUT: `${BASE_URL}/user-logout`,
  USER_GET_CURRENT: `${BASE_URL}/user-get-current`,
  USER_UPDATE: `${BASE_URL}/user-update`,
  MY_PROGRAM_GOALS: `${BASE_URL}/profiles/fellow-data/my-goals/`,
  USER_UPLOAD_AVATAR: `${BASE_URL}/upload-user-avatar-image`,
  USER_FORGOT_PASSWORD: `${BASE_URL}/forgot-password`,
  MAGIC_LINK_REQUEST: `${BASE_URL}/magic-link/request/`,
  MAGIC_LINK_VERIFY: `${BASE_URL}/magic-link/verify/`,
  USER_RESET_PASSWORD: (token: string | number): string => `${BASE_URL}/change-password/${token}`,

  GET_USERS: `${BASE_URL}/users/`,
  GET_ALL_USERS: `${BASE_URL}/users/all/`,

  GET_BACHELORS_DEGREE_OPTIONS: `${BASE_URL}/get-bachelors-degree`,
  GET_GENDERS: `${BASE_URL}/get-genders`,
  GET_USER_JOB_ROLES: `${BASE_URL}/get-user-job-roles`,
  GET_COUNTRIES: `${BASE_URL}/get-countries`,
  GET_CITIES: `${BASE_URL}/get-cities`,
  CHECK_USERNAME_UNIQUENESS: `${BASE_URL}/check-username-uniqueness`,
  CHECK_EMAIL_UNIQUENESS: `${BASE_URL}/check-email-uniqueness`,

  GET_EXPEDITIONS_LIST: `${BASE_URL}/curriculum/get-expeditions-list`,
  GET_GUIDE_PODS: `${BASE_URL}/personal-curriculum/guide/pods/`,
  GET_EXPEDITION_JOB_APPLICATION_STATISTICS: (expeditionId: string | number) =>
    `${BASE_URL}/job_applications/expedition-statistics/${expeditionId}/`,
  GET_POD_JOB_APPLICATION_STATISTICS: (podId: string | number) =>
    `${BASE_URL}/job_applications/pod-statistics/${podId}/`,
  GET_USERS_JOB_APPLICATION_STATISTICS: `${BASE_URL}/job_applications/users-statistics/`,

  GET_INTERVIEW_LIST: `${BASE_URL}/interviews/get-interviews`,
  GET_INTERVIEW_DETAIL: (interviewId: string | number): string => `${BASE_URL}/interviews/get-interview/${interviewId}/`,
  GET_INTERVIEW_ROLENAMES: `${BASE_URL}/interviews/get-role-names/`,
  GET_INTERVIEW_TYPES: `${BASE_URL}/interviews/get-interview-types/`,
  GET_INTERVIEW_MODES: `${BASE_URL}/interviews/get-interview-modes/`,
  GET_INTERVIEW_SET_TYPES: `${BASE_URL}/interviews/get-interview-set-types/`,
  GET_INTERVIEW_RESULTS: `${BASE_URL}/interviews/get-interview-results/`,
  GET_INTERVIEW_MULTIPLE_FILTERS: `${BASE_URL}/interviews/get-interviews-multiple-filters/`,
  GET_INTERVIEW_BY_USER: (userId: string | number): string => `${BASE_URL}/interviews/get-interviews-by-user/${userId}/`,
  CREATE_INTERVIEW: `${BASE_URL}/interviews/create-interview`,
  PARTIAL_UPDATE_INTERVIEW: (interviewId: string | number): string => `${BASE_URL}/interviews/partial-update-interview/${interviewId}/`,
  DELETE_INTERVIEW: (interviewId: string | number): string => `${BASE_URL}/interviews/delete-interview/${interviewId}/`,

  // GET_EMPLOYER_LIST: `${BASE_URL}/employers/get-employers-list`,
  GET_EMPLOYERS_OPTIONS: `${BASE_URL}/employers/get-employers-options/`,
  CREATE_EMPLOYER: `${BASE_URL}/employers/create-employer`,
  CHECK_EMPLOYER_EXISTENCE: `${BASE_URL}/employers/check-employer-existence/`,
  CHECK_ROLENAME_EXISTENCE: `${BASE_URL}/employers/check-role-name-existence/`,
  UPDATE_EMPLOYER: (employerId: string | number): string => `${BASE_URL}/employers/update-employer/${employerId}/`,
  GET_REFERRING_COMPANIES_SHOWCASE: `${BASE_URL}/employers/referring-companies/showcase/`,
  GET_REFERRING_COMPANIES: `${BASE_URL}/employers/referring-companies/`,

  GET_ROLES: `${BASE_URL}/job_applications/roles/`,
  GET_ROLE_BY_ID: (roleId: string | number): string => `${BASE_URL}/job_applications/roles/${roleId}/`,
  UPDATE_ROLE: (roleId: string | number): string => `${BASE_URL}/job_applications/roles/${roleId}/`,
  CREATE_ROLE: `${BASE_URL}/job_applications/roles/`,
  DELETE_ROLE: (roleId: string | number): string => `${BASE_URL}/job_applications/roles/${roleId}/`,
  UPDATE_ROLE_APPLICATION: (roleId: string | number): string => `${BASE_URL}/job_applications/roles/${roleId}/update-application/`,
  CHECK_URL_UNIQUE: `${BASE_URL}/job_applications/roles/check-url-unique/`,
  AUTOFILL_FROM_URL: `${BASE_URL}/job_applications/roles/autofill-from-url/`,

  GET_ALL_APPLICATIONS: `${BASE_URL}/job_applications/applications/`,
  GET_USER_APPLICATIONS: `${BASE_URL}/job_applications/applications/my-applications/`,
  GET_APPLICATIONS_BY_USER_ID: (userId: string | number): string => `${BASE_URL}/job_applications/applications/by-user/${userId}/`,
  GET_USER_APPLICATION_BY_ID: (id: string) => `${BASE_URL}/job_applications/applications/${id}`,
  CREATE_USER_APPLICATION: `${BASE_URL}/job_applications/applications/`,
  UPDATE_USER_APPLICATION: (id: string) => `${BASE_URL}/job_applications/applications/${id}/`,
  DELETE_USER_APPLICATION: (id: string) => `${BASE_URL}/job_applications/applications/${id}/`,
  UPDATE_USER_APPLICATION_STATUS: (id: string) => `${BASE_URL}/job_applications/applications/update-status/${id}/`,
  CREATE_PRIVATE_JOB_APPLICATION: `${BASE_URL}/job_applications/applications/private-job-application/`,
  GUIDE_EDIT_APPLICATION: (id: string | number): string => `${BASE_URL}/job_applications/applications/${id}/guide-edit/`,

  PREVIEW_REFERRAL_EMAIL: (id: string) => `${BASE_URL}/job_applications/applications/${id}/email/preview/`,
  SEND_REFERRAL_EMAIL: (id: string) => `${BASE_URL}/job_applications/applications/${id}/email/send/`,

  GET_RESUME_BY_ID: (id: string | number) => `${BASE_URL}/job_applications/resumes/${id}/`,
  UPDATE_RESUME_BY_ID: (id: string | number) => `${BASE_URL}/job_applications/resumes/${id}/`,
  CREATE_RESUME_BY_ID: (id: string | number) => `${BASE_URL}/job_applications/resumes/${id}/`,

  // Resume Files (PDF uploads)
  RESUME_FILES_LIST: `${BASE_URL}/job_applications/resume-files/`,
  RESUME_FILE_DETAIL: (id: string | number) => `${BASE_URL}/job_applications/resume-files/${id}/`,
  RESUME_FILE_REPLACE: (id: string | number) => `${BASE_URL}/job_applications/resume-files/${id}/replace-file/`,
  RESUME_FILE_SET_DEFAULT: (id: string | number) => `${BASE_URL}/job_applications/resume-files/${id}/set-default/`,
  RESUME_FILE_UNSET_DEFAULT: (id: string | number) => `${BASE_URL}/job_applications/resume-files/${id}/unset-default/`,
  RESUME_FILE_APPROVE: (id: string | number) => `${BASE_URL}/job_applications/resume-files/${id}/approve/`,
  RESUME_FILE_REQUEST_REVISION: (id: string | number) => `${BASE_URL}/job_applications/resume-files/${id}/request-revision/`,

  GET_REFERRALS: `${BASE_URL}/job_applications/referrals/`,
  CREATE_REFERRAL: `${BASE_URL}/job_applications/referrals/`,
  GET_REFERRAL_BY_ID: (id: string | number) => `${BASE_URL}/job_applications/referrals/${id}/`,
  UPDATE_REFERRAL_BY_ID: (id: string | number) => `${BASE_URL}/job_applications/referrals/${id}/`,

  GET_ALLOWED_LOCATIONS: `${BASE_URL}/job_applications/allowed-locations/`,
  CREATE_ALLOWED_LOCATION: `${BASE_URL}/job_applications/allowed-locations/`,
  GET_ALLOWED_LOCATIONS_OPTIONS: `${BASE_URL}/job_applications/allowed-locations-options/`,
  GET_JOB_LOCATIONS: `${BASE_URL}/job_applications/job-locations/`,

  GET_REFERRERS: `${BASE_URL}/job_applications/referrers/`,
  CREATE_REFERRER: `${BASE_URL}/job_applications/referrers/`,
  UPDATE_REFERRER: (id: string | number) => `${BASE_URL}/job_applications/referrers/${id}/`,
  PATCH_REFERRER: (id: string | number) => `${BASE_URL}/job_applications/referrers/${id}/`,
  GET_REFERRERS_GROUPED_BY_COMPANY: `${BASE_URL}/job_applications/referrers/grouped_by_company/`,
  SET_DEFAULT_REFERRER: (employerId: string | number) => `${BASE_URL}/employers/${employerId}/set-default-referrer/`,
  GET_REFERRER_STATS: `${BASE_URL}/job_applications/referrers/stats/`,

  GET_RECRUITERS: `${BASE_URL}/job_applications/recruiters/`,

  // Personal applications endpoints
  GET_PERSONAL_APPLICATION: (id: string | number) => `${BASE_URL}/job_applications/applications/personal/${id}/`,
  UPDATE_PERSONAL_APPLICATION: (id: string | number) => `${BASE_URL}/job_applications/applications/personal/${id}/`,
  DELETE_PERSONAL_APPLICATION: (id: string | number) => `${BASE_URL}/job_applications/applications/personal/${id}/`,

  GET_BATCH_CHOICES: `${BASE_URL}/profiles/fellow-data/batch-choices/`,

  GET_APPLICANTS_LIST: `${BASE_URL}/job_applications/applicants/`,
  GET_LATEST_UPDATED_APPLICANTS: `${BASE_URL}/job_applications/applicants/latest-updated/`,

  GET_APPLICANT_PROFILE: `${BASE_URL}/job_applications/applicant-profile/`,
  GET_APPLICANT_PROFILES: `${BASE_URL}/job_applications/applicant-profiles/`,
  GET_APPLICANT_PROFILE_BY_USER_ID: (userId: string | number) => `${BASE_URL}/job_applications/applicant-profiles/${userId}/`,
  UPDATE_REFERRAL_PACKAGE: (id: string | number) => `${BASE_URL}/job_applications/referral-packages/${id}/`,

  GET_REFERRAL_REQUESTS: `${BASE_URL}/job_applications/applications/referral-requests/`,
  REFERRER_MY_APPLICATIONS: `${BASE_URL}/job_applications/referrer/my-applications/`,
  REFERRER_UPDATE_REFERRAL_STATUS: (id: string | number) => `${BASE_URL}/job_applications/referrer/applications/${id}/referral-status/`,
  REFERRER_MY_STATISTICS: `${BASE_URL}/job_applications/referrer/my-statistics/`,
  REFERRER_LEADERBOARD: `${BASE_URL}/job_applications/referrer/leaderboard/`,
  SMART_SEARCH_LOCATIONS: `${BASE_URL}/job_applications/locations/smart-search/`,
  CREATE_JOB_LOCATION: `${BASE_URL}/job_applications/locations/create/`,

  MATCH_RESUME_TO_JOB: (id: string | number) => `${BASE_URL}/job_applications/applications/${id}/match-job/`,
    
  // Referral action endpoints (public, no auth required)
  REFERRAL_ACTION_VALIDATE: (token: string) => `${BASE_URL}/job_applications/referral-action/${token}/validate/`,
  REFERRAL_ACTION_CONFIRM: (token: string) => `${BASE_URL}/job_applications/referral-action/${token}/confirm/`,
  REFERRAL_ACTION_DECLINE: (token: string) => `${BASE_URL}/job_applications/referral-action/${token}/decline/`,
  REFERRAL_ACTION_PROVIDE_LINK: (token: string) => `${BASE_URL}/job_applications/referral-action/${token}/provide-link/`,

  // Subscription endpoints
  SUBSCRIPTION_ACCESS_STATUS: `${BASE_URL}/subscriptions/access/status/`,

  // Social Auth API Routes
  SOCIAL_AUTH_GOOGLE_LOGIN: `${BASE_URL}/auth/google/login/`,
  SOCIAL_AUTH_LINKEDIN_LOGIN: `${BASE_URL}/auth/linkedin/login/`,
  SOCIAL_AUTH_PROFILE_STATUS: `${BASE_URL}/users/profile-status/`,
  SOCIAL_AUTH_COMPLETE_PROFILE: `${BASE_URL}/users/complete-profile/`,
} as const;
